import { Button, Spin, Tabs } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PlayersPage.module.less';
import TestUsersTab from './TestUsersTab';
const { TabPane } = Tabs;

export default function PlayersPage() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  if (isLoading) {
    return <Spin />;
  }
  return (
    <>
      <div className={styles.playersDetailsContainer}>
        <div className="page-head">
          <div>
            <h2 className="h2">{t('playersPage.Header')}</h2>
          </div>
        </div>
        <Tabs defaultActiveKey="1">
          <TabPane tab={t('playersPage.Tab.Users')} key="1">
            <TestUsersTab />
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}
